module.exports = __webpack_public_path__ + "static/img/user1.eb69d72c.png";